import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collapsable',
  templateUrl: './app-collapsable.component.html',
  styleUrls: ['./app-collapsable.component.css']
})
export class AppCollapsableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
